var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cv-toast-notification',{attrs:{"kind":_vm.kind,"title":_vm.message,"sub-title":_vm.subTitle,"caption":_vm.caption,"close-aria-label":"Close","low-contrast":""},on:{"close":function($event){return _vm.$emit('remove')}}})}
var staticRenderFns = []

export { render, staticRenderFns }